export default "__VITE_ASSET__BkSkk1jX__"